import React from "react";
import AddInfo from "./AddInfo";

function FloatRight() {
  return (
    <div>
      <AddInfo />
    </div>
  );
}

export default FloatRight;
